// Verbatim-инвариант — программная гарантия (spec §5).
//
// LLM возвращает текст фразы (не координаты — §5 обоснование: модели не считают
// оффсеты). Программа ищет фразу как точную подстроку исходного T-поля с
// нормализацией whitespace. Найдено → дословный срез ИСХОДНОГО поля (сохраняем
// оригинальную пунктуацию/whitespace). Не найдено (перефраз) → null → fallback.

/**
 * Нормализует whitespace и строит map: позиция нормализованного символа →
 * индекс в исходной строке. Схлопывает пробельные прогоны в один пробел,
 * trim по краям.
 */
function normalizeWithMap(s) {
  let normalized = '';
  const map = [];
  let prevSpace = true; // start as space → срезает ведущие пробелы
  for (let i = 0; i < s.length; i++) {
    const ch = s[i];
    if (/\s/.test(ch)) {
      if (!prevSpace) {
        normalized += ' ';
        map.push(i);
        prevSpace = true;
      }
    } else {
      normalized += ch;
      map.push(i);
      prevSpace = false;
    }
  }
  if (normalized.endsWith(' ')) {
    normalized = normalized.slice(0, -1);
    map.pop();
  }
  return { normalized, map };
}

/**
 * Проверяет verbatim-инвариант и возвращает дословный срез исходного поля.
 *
 * @param {string} phrase  фраза, возвращённая LLM
 * @param {string} source  исходное T-поле
 * @returns {string|null}  дословный срез source или null, если phrase не
 *                         является (whitespace-нормализованной) подстрокой
 */
export function verbatimSlice(phrase, source) {
  if (typeof phrase !== 'string' || typeof source !== 'string') return null;
  const { normalized: np } = normalizeWithMap(phrase);
  if (np === '') return null;

  const { normalized: ns, map } = normalizeWithMap(source);
  const idx = ns.indexOf(np);
  if (idx === -1) return null;

  const start = map[idx];
  const end = map[idx + np.length - 1] + 1; // +1: срез исключает правый край
  return source.slice(start, end);
}
